import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetPasscodeRequest } from '@cash-web/shared-util-protos/squareup/franklin/SetPasscodeRequestProto.pb'
import { SetPasscodeResponse } from '@cash-web/shared-util-protos/squareup/franklin/SetPasscodeResponseProto.pb'

export const setPasscode = (request: SetPasscodeRequest, options?: CashRequestOptions) =>
  post<SetPasscodeRequest, SetPasscodeResponse>('/2.0/cash/set-passcode', request, { ...options, rejectOnError: true })
